export const defaultLayout = [
    {
        x: 0,
        y: 0,
        w: 14,
        h: 6,
        maxH: 100,
        maxW: 24,
        minW: 14,
        minH: 6,
        i: 'card-total-cost',
        moved: false,
        deleted: false
    },
    {
        x: 14,
        y: 0,
        w: 10,
        h: 6,
        maxH: 100,
        maxW: 24,
        minW: 10,
        minH: 6,
        i: 'card-download',
        moved: false,
        deleted: false
    },
    {
        x: 0,
        y: 6,
        w: 14,
        h: 9,
        maxH: 100,
        maxW: 24,
        minW: 14,
        minH: 9,
        i: 'card-months',
        moved: false,
        deleted: false
    },
    {
        x: 14,
        y: 6,
        w: 10,
        h: 9,
        maxH: 100,
        maxW: 24,
        minW: 10,
        minH: 9,
        i: 'card-weeks',
        moved: false,
        deleted: false
    },
    {
        x: 0,
        y: 15,
        w: 24,
        h: 9,
        maxH: 100,
        maxW: 24,
        minW: 24,
        minH: 9,
        i: 'card-dates',
        moved: false,
        deleted: false
    },
    {
        x: 0,
        y: 24,
        w: 10,
        h: 13,
        maxH: 100,
        maxW: 24,
        minW: 10,
        minH: 13,
        i: 'card-products',
        moved: false,
        deleted: false
    },
    {
        x: 10,
        y: 24,
        w: 14,
        h: 13,
        maxH: 100,
        maxW: 24,
        minW: 14,
        minH: 13,
        i: 'card-regions',
        moved: false,
        deleted: false
    },
    {
        x: 0,
        y: 37,
        w: 14,
        h: 10,
        maxW: 14,
        maxH: 10,
        minW: 14,
        minH: 10,
        i: 'card-banner',
        moved: false,
        deleted: false
    },
    {
        x: 14,
        y: 37,
        w: 10,
        h: 9,
        maxH: 100,
        maxW: 24,
        minW: 10,
        minH: 9,
        i: 'card-board',
        moved: false,
        deleted: false
    },
    {
        x: 14,
        y: 46,
        w: 10,
        h: 5,
        maxH: 100,
        maxW: 24,
        minW: 10,
        minH: 5,
        i: 'card-statistics',
        moved: false,
        deleted: false
    }
]
export const additionalLayout = [
    {
        x: 0,
        y: 51,
        w: 24,
        h: 11,
        maxH: 100,
        maxW: 24,
        minW: 24,
        minH: 11,
        i: 'card-dates-detail',
        moved: false,
        deleted: false
    }
]
export const summaryLayout = [
    {
        x: 0,
        y: 51,
        w: 6,
        h: 20,
        maxW: 24,
        maxH: 100,
        minW: 6,
        minH: 20,
        i: 'summary-card-sidebar',
        moved: false,
        deleted: false
    },
    {
        x: 6,
        y: 51,
        w: 9,
        h: 12,
        maxW: 24,
        maxH: 100,
        minW: 8,
        minH: 12,
        i: 'summary-card-products',
        moved: false,
        deleted: false
    },
    {
        x: 15,
        y: 51,
        w: 9,
        h: 12,
        maxW: 24,
        maxH: 100,
        minW: 8,
        minH: 12,
        i: 'summary-card-regions',
        moved: false,
        deleted: false
    },
    {
        x: 6,
        y: 63,
        w: 18,
        h: 10,
        maxW: 24,
        maxH: 100,
        minW: 12,
        minH: 10,
        i: 'summary-card-dates',
        moved: false,
        deleted: false
    },
    {
        x: 6,
        y: 73,
        w: 18,
        h: 10,
        maxW: 24,
        maxH: 100,
        minW: 12,
        minH: 10,
        i: 'summary-card-weeks',
        moved: false,
        deleted: false
    }
]

export const defaultLayoutMap = defaultLayout
    .concat(additionalLayout)
    .concat(summaryLayout)
    .reduce((acc, cur) => {
        acc[cur.i] = cur
        return acc
    }, {})

export const dummyBoardDocuments = [
    {
        'key': 'boards/dummy/001',
        'service': 'all',
        'timestamp': '1683589898236',
        'status': 'active',
        'subject': 'Hyper Billing Release v3.0.8',
        'modified': '2023-05-08T23:51:50.000Z'
    },
    {
        'key': 'boards/dummy/002',
        'service': 'all',
        'timestamp': '1675757768504',
        'status': 'active',
        'subject': 'Hyper Billing Release v3.0.7',
        'modified': '2023-02-07T08:16:34.000Z'
    },
    {
        'key': 'boards/dummy/003',
        'service': 'all',
        'timestamp': '1675757768504',
        'status': 'active',
        'subject': 'Hyper Billing Release v3.0.6',
        'modified': '2023-02-07T08:16:34.000Z'
    },
    {
        'key': 'boards/dummy/003',
        'service': 'all',
        'timestamp': '1673407768504',
        'status': 'active',
        'subject': 'Hyper Billing Release v3.0.5',
        'modified': '2023-02-07T08:16:34.000Z'
    },
    {
        'key': 'boards/dummy/003',
        'service': 'all',
        'timestamp': '1671407768504',
        'status': 'active',
        'subject': 'Hyper Billing Release v3.0.4',
        'modified': '2023-02-07T08:16:34.000Z'
    }
]

export const statistics = {
    'accounts': 5,
    'lineitems': 408,
    'products': 408
}

export const prevmonth = {
    'date': '2024-05-21',
    'cost': 103280,
    'lastMonthCost': 105700,
    'monthIncreasedRate': 12.22
}

export const estimatedCost = {
    'date': '2024-05-21',
    'cost': 103280,
    'lastMonthCost': 105700,
    'estimatedCost': 173120,
    'estimatedIncreasedRate': 67.62
}
export const invoiceCheck = false

export const regions = {
    'lastMonthRegions': [
        {
            'key': 'USW2',
            'cost': 31109.233382065257
        },
        {
            'key': 'APN2',
            'cost': 18123.961091836074
        },
        {
            'key': 'USE1',
            'cost': 75.71311821137
        },
        {
            'key': 'AP',
            'cost': 0.3785253
        },
        {
            'key': 'US',
            'cost': 0.023989
        },
        {
            'key': 'EU',
            'cost': 0.15668458684
        }
    ],
    'thisMonthRegions': [
        {
            'key': 'USW2',
            'cost': 24362.583626851367
        },
        {
            'key': 'APN2',
            'cost': 14019.635515320624
        },
        {
            'key': 'USE1',
            'cost': 63.412742025383
        },
        {
            'key': 'AP',
            'cost': 0.2079384
        },
        {
            'key': 'US',
            'cost': 0.0634035
        },
        {
            'key': 'EU',
            'cost': 0.121279413244
        }
    ]
}

export const months = {
    maxCost: 150000,
    list: [
        {
            month: '2023-06',
            cost: 131350
        },

        {
            month: '2023-07',
            cost: 81250
        },
        {
            month: '2023-08',
            cost: 94550
        },
        {
            month: '2023-09',
            cost: 115200
        },
        {
            month: '2023-10',
            cost: 121250
        },
        {
            month: '2023-11',
            cost: 150000
        },
        {
            month: '2023-12',
            cost: 121200
        },
        {
            month: '2024-01',
            cost: 121240
        },
        {
            month: '2024-02',
            cost: 131250
        },
        {
            month: '2024-03',
            cost: 175120
        },
        {
            month: '2024-04',
            cost: 105700
        },
        {
            month: '2024-05',
            cost: 103280
        }
    ]
}

export const weeks = { 'days': ['1', '2', '3', '4', '5', '6', '7'], 'yKeys': [18, 19, 20, 21], 'weeklyCost': { '18': [1697, 1688, 1672, 1645, 1696, 1668, 1616], '19': [1608, 1709, 1632, 1636, 1635, 1636, 1643], '20': [1644, 1663, 1663, 1661, 1667, 1663, 1664], '21': [1685, 1690, 1691, 1694, 755] }, 'weeks': [{ 'week': 18, 'day': '1', 'date': '2024-04-29', 'cost': 1697 }, { 'week': 18, 'day': '2', 'date': '2024-04-30', 'cost': 1688 }, { 'week': 18, 'day': '3', 'date': '2024-05-01', 'cost': 1672 }, { 'week': 18, 'day': '4', 'date': '2024-05-02', 'cost': 1645 }, { 'week': 18, 'day': '5', 'date': '2024-05-03', 'cost': 1696 }, { 'week': 18, 'day': '6', 'date': '2024-05-04', 'cost': 1668 }, { 'week': 18, 'day': '7', 'date': '2024-05-05', 'cost': 1616 }, { 'week': 19, 'day': '1', 'date': '2024-05-06', 'cost': 1608 }, { 'week': 19, 'day': '2', 'date': '2024-05-07', 'cost': 1709 }, { 'week': 19, 'day': '3', 'date': '2024-05-08', 'cost': 1632 }, { 'week': 19, 'day': '4', 'date': '2024-05-09', 'cost': 1636 }, { 'week': 19, 'day': '5', 'date': '2024-05-10', 'cost': 1635 }, { 'week': 19, 'day': '6', 'date': '2024-05-11', 'cost': 1636 }, { 'week': 19, 'day': '7', 'date': '2024-05-12', 'cost': 1643 }, { 'week': 20, 'day': '1', 'date': '2024-05-13', 'cost': 1644 }, { 'week': 20, 'day': '2', 'date': '2024-05-14', 'cost': 1663 }, { 'week': 20, 'day': '3', 'date': '2024-05-15', 'cost': 1663 }, { 'week': 20, 'day': '4', 'date': '2024-05-16', 'cost': 1661 }, { 'week': 20, 'day': '5', 'date': '2024-05-17', 'cost': 1667 }, { 'week': 20, 'day': '6', 'date': '2024-05-18', 'cost': 1663 }, { 'week': 20, 'day': '7', 'date': '2024-05-19', 'cost': 1664 }, { 'week': 21, 'day': '1', 'date': '2024-05-20', 'cost': 1685 }, { 'week': 21, 'day': '2', 'date': '2024-05-21', 'cost': 1690 }, { 'week': 21, 'day': '3', 'date': '2024-05-22', 'cost': 1691 }, { 'week': 21, 'day': '4', 'date': '2024-05-23', 'cost': 1694 }, { 'week': 21, 'day': '5', 'date': '2024-05-24', 'cost': 755 }] }

export const dates = {
    lineChartData: [
        1672, 3317, 5014, 6683, 8299, 9908, 11618, 13250, 14886, 16522, 18159,
        19803, 21448, 23111, 24774, 26436, 28104, 29767, 31432, 33117, 34808, 36499,
        38194, 8950
    ],
    barChartData: [
        1672, 1645, 1696, 1668, 1616, 1608, 1709, 1632, 1636, 1635, 1636, 1643,
        1644, 1663, 1663, 1661, 1667, 1663, 1664, 1685, 1690, 1691, 1694, 755
    ],
    labels: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24'
    ],
    dates: [
        {
            date: '2024-05-01',
            cost: 1672,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 702.24 },
                { productCode: 'AmazonEC2', cost: 401.28000000000003 },
                { productCode: 'AmazonRDS', cost: 250.79999999999998 },
                { productCode: 'AmazonCloudWatch', cost: 200.64000000000001 },
                { productCode: 'AWSCloudTrail', cost: 117.04 }
            ]
        },
        {
            date: '2024-05-02',
            cost: 1645,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 690.9 },
                { productCode: 'AmazonEC2', cost: 394.8 },
                { productCode: 'AmazonRDS', cost: 246.75 },
                { productCode: 'AmazonCloudWatch', cost: 197.4 },
                { productCode: 'AWSCloudTrail', cost: 115.15 }
            ]
        },
        {
            date: '2024-05-03',
            cost: 1696,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 712.3199999999999 },
                { productCode: 'AmazonEC2', cost: 407.04 },
                { productCode: 'AmazonRDS', cost: 254.39999999999998 },
                { productCode: 'AmazonCloudWatch', cost: 203.52 },
                { productCode: 'AWSCloudTrail', cost: 118.72000000000001 }
            ]
        },
        {
            date: '2024-05-04',
            cost: 1668,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 700.56 },
                { productCode: 'AmazonEC2', cost: 400.32000000000005 },
                { productCode: 'AmazonRDS', cost: 250.2 },
                { productCode: 'AmazonCloudWatch', cost: 200.16000000000003 },
                { productCode: 'AWSCloudTrail', cost: 116.76 }
            ]
        },
        {
            date: '2024-05-05',
            cost: 1616,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 678.72 },
                { productCode: 'AmazonEC2', cost: 387.84000000000003 },
                { productCode: 'AmazonRDS', cost: 242.39999999999998 },
                { productCode: 'AmazonCloudWatch', cost: 193.92000000000002 },
                { productCode: 'AWSCloudTrail', cost: 113.12 }
            ]
        },
        {
            date: '2024-05-06',
            cost: 1608,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 675.36 },
                { productCode: 'AmazonEC2', cost: 385.92 },
                { productCode: 'AmazonRDS', cost: 241.2 },
                { productCode: 'AmazonCloudWatch', cost: 192.96 },
                { productCode: 'AWSCloudTrail', cost: 112.56000000000002 }
            ]
        },
        {
            date: '2024-05-07',
            cost: 1709,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 717.78 },
                { productCode: 'AmazonEC2', cost: 410.16 },
                { productCode: 'AmazonRDS', cost: 256.34999999999997 },
                { productCode: 'AmazonCloudWatch', cost: 205.08 },
                { productCode: 'AWSCloudTrail', cost: 119.63000000000001 }
            ]
        },
        {
            date: '2024-05-08',
            cost: 1632,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 685.4399999999999 },
                { productCode: 'AmazonEC2', cost: 391.68 },
                { productCode: 'AmazonRDS', cost: 244.79999999999998 },
                { productCode: 'AmazonCloudWatch', cost: 195.84 },
                { productCode: 'AWSCloudTrail', cost: 114.24000000000001 }
            ]
        },
        {
            date: '2024-05-09',
            cost: 1636,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 687.12 },
                { productCode: 'AmazonEC2', cost: 392.64000000000004 },
                { productCode: 'AmazonRDS', cost: 245.39999999999998 },
                { productCode: 'AmazonCloudWatch', cost: 196.32000000000002 },
                { productCode: 'AWSCloudTrail', cost: 114.52000000000001 }
            ]
        },
        {
            date: '2024-05-10',
            cost: 1635,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 686.6999999999999 },
                { productCode: 'AmazonEC2', cost: 392.40000000000003 },
                { productCode: 'AmazonRDS', cost: 245.25 },
                { productCode: 'AmazonCloudWatch', cost: 196.20000000000002 },
                { productCode: 'AWSCloudTrail', cost: 114.45000000000002 }
            ]
        },
        {
            date: '2024-05-11',
            cost: 1636,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 687.12 },
                { productCode: 'AmazonEC2', cost: 392.64000000000004 },
                { productCode: 'AmazonRDS', cost: 245.39999999999998 },
                { productCode: 'AmazonCloudWatch', cost: 196.32000000000002 },
                { productCode: 'AWSCloudTrail', cost: 114.52000000000001 }
            ]
        },
        {
            date: '2024-05-12',
            cost: 1643,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 690.06 },
                { productCode: 'AmazonEC2', cost: 394.32000000000005 },
                { productCode: 'AmazonRDS', cost: 246.45 },
                { productCode: 'AmazonCloudWatch', cost: 197.16000000000003 },
                { productCode: 'AWSCloudTrail', cost: 115.01 }
            ]
        },
        {
            date: '2024-05-13',
            cost: 1644,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 690.48 },
                { productCode: 'AmazonEC2', cost: 394.56000000000006 },
                { productCode: 'AmazonRDS', cost: 246.6 },
                { productCode: 'AmazonCloudWatch', cost: 197.28000000000003 },
                { productCode: 'AWSCloudTrail', cost: 115.08000000000001 }
            ]
        },
        {
            date: '2024-05-14',
            cost: 1663,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 698.4599999999999 },
                { productCode: 'AmazonEC2', cost: 399.12 },
                { productCode: 'AmazonRDS', cost: 249.45 },
                { productCode: 'AmazonCloudWatch', cost: 199.56 },
                { productCode: 'AWSCloudTrail', cost: 116.41000000000001 }
            ]
        },
        {
            date: '2024-05-15',
            cost: 1663,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 698.4599999999999 },
                { productCode: 'AmazonEC2', cost: 399.12 },
                { productCode: 'AmazonRDS', cost: 249.45 },
                { productCode: 'AmazonCloudWatch', cost: 199.56 },
                { productCode: 'AWSCloudTrail', cost: 116.41000000000001 }
            ]
        },
        {
            date: '2024-05-16',
            cost: 1661,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 697.62 },
                { productCode: 'AmazonEC2', cost: 398.64000000000004 },
                { productCode: 'AmazonRDS', cost: 249.14999999999998 },
                { productCode: 'AmazonCloudWatch', cost: 199.32000000000002 },
                { productCode: 'AWSCloudTrail', cost: 116.27000000000001 }
            ]
        },
        {
            date: '2024-05-17',
            cost: 1667,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 700.14 },
                { productCode: 'AmazonEC2', cost: 400.08000000000004 },
                { productCode: 'AmazonRDS', cost: 250.04999999999998 },
                { productCode: 'AmazonCloudWatch', cost: 200.04000000000002 },
                { productCode: 'AWSCloudTrail', cost: 116.69000000000001 }
            ]
        },
        {
            date: '2024-05-18',
            cost: 1663,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 698.4599999999999 },
                { productCode: 'AmazonEC2', cost: 399.12 },
                { productCode: 'AmazonRDS', cost: 249.45 },
                { productCode: 'AmazonCloudWatch', cost: 199.56 },
                { productCode: 'AWSCloudTrail', cost: 116.41000000000001 }
            ]
        },
        {
            date: '2024-05-19',
            cost: 1664,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 698.88 },
                { productCode: 'AmazonEC2', cost: 399.36 },
                { productCode: 'AmazonRDS', cost: 249.6 },
                { productCode: 'AmazonCloudWatch', cost: 199.68 },
                { productCode: 'AWSCloudTrail', cost: 116.48000000000002 }
            ]
        },
        {
            date: '2024-05-20',
            cost: 1685,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 707.6999999999999 },
                { productCode: 'AmazonEC2', cost: 404.40000000000003 },
                { productCode: 'AmazonRDS', cost: 252.75 },
                { productCode: 'AmazonCloudWatch', cost: 202.20000000000002 },
                { productCode: 'AWSCloudTrail', cost: 117.95000000000002 }
            ]
        },
        {
            date: '2024-05-21',
            cost: 1690,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 709.8 },
                { productCode: 'AmazonEC2', cost: 405.6 },
                { productCode: 'AmazonRDS', cost: 253.5 },
                { productCode: 'AmazonCloudWatch', cost: 202.8 },
                { productCode: 'AWSCloudTrail', cost: 118.30000000000001 }
            ]
        },
        {
            date: '2024-05-22',
            cost: 1691,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 710.22 },
                { productCode: 'AmazonEC2', cost: 405.84000000000003 },
                { productCode: 'AmazonRDS', cost: 253.64999999999998 },
                { productCode: 'AmazonCloudWatch', cost: 202.92000000000002 },
                { productCode: 'AWSCloudTrail', cost: 118.37 }
            ]
        },
        {
            date: '2024-05-23',
            cost: 1694,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 711.48 },
                { productCode: 'AmazonEC2', cost: 406.56000000000006 },
                { productCode: 'AmazonRDS', cost: 254.1 },
                { productCode: 'AmazonCloudWatch', cost: 203.28000000000003 },
                { productCode: 'AWSCloudTrail', cost: 118.58000000000001 }
            ]
        },
        {
            date: '2024-05-24',
            cost: 755,
            products: [
                { productCode: 'AmazonDynamoDB', cost: 317.09999999999997 },
                { productCode: 'AmazonEC2', cost: 181.20000000000002 },
                { productCode: 'AmazonRDS', cost: 113.25 },
                { productCode: 'AmazonCloudWatch', cost: 90.60000000000001 },
                { productCode: 'AWSCloudTrail', cost: 52.85000000000001 }
            ]
        }
    ]
}

export const products = {
    thisMonthProducts: [
        { productCode: 'AmazonDynamoDB', cost: 43377.6 },
        { productCode: 'AmazonEC2', cost: 24787.2 },
        { productCode: 'AmazonRDS', cost: 15492 },
        { productCode: 'AmazonCloudWatch', cost: 12393.6 },
        { productCode: 'AWSCloudTrail', cost: 7229.6 }
    ],
    lastMonthProducts: []
}

export const monthCost = 103280
